import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import Image from 'next/image';
import Button from '@/components/Button';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CirclePlayIcon = function CirclePlayIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5 17.1666C14.1819 17.1666 17.1667 14.1819 17.1667 10.5C17.1667 6.81806 14.1819 3.83329 10.5 3.83329C6.81812 3.83329 3.83335 6.81806 3.83335 10.5C3.83335 14.1819 6.81812 17.1666 10.5 17.1666ZM10.5 18.8333C15.1024 18.8333 18.8334 15.1023 18.8334 10.5C18.8334 5.89759 15.1024 2.16663 10.5 2.16663C5.89765 2.16663 2.16669 5.89759 2.16669 10.5C2.16669 15.1023 5.89765 18.8333 10.5 18.8333Z",
      fill: "#515466"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 8.00258C8 7.35539 8.70557 6.95522 9.26102 7.28737L13.4253 9.77758C13.9716 10.1042 13.9716 10.8957 13.4253 11.2223L9.26101 13.7124C8.70555 14.0445 8 13.6444 8 12.9972V8.00258Z",
      fill: "#12131A"
    })]
  }));
};

CirclePlayIcon.defaultProps = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const TutorialEmptyState = _ref => {
  let {
    tutorial,
    className,
    onSelectTutorial
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles.container, className),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.image,
          children: /*#__PURE__*/_jsx(Image, {
            src: tutorial.imgSrc,
            width: 62,
            height: 62,
            alt: "tutorial img"
          })
        }), /*#__PURE__*/_jsx("span", {
          className: styles.title,
          children: tutorial.title
        }), tutorial.videoTitle && onSelectTutorial && /*#__PURE__*/_jsx(Button, {
          variant: "link",
          type: "button",
          leftIcon: /*#__PURE__*/_jsx(CirclePlayIcon, {}),
          onClick: onSelectTutorial,
          className: styles.linkButton,
          children: tutorial.videoTitle
        })]
      })
    })
  });
};

export default TutorialEmptyState;